import React from 'react';
import SideMenuBar from '../../../Components/Layouts/SideMenuBar';
import TopMenuBar from '../../../Components/Layouts/TopMenuBar';
import RightSideBar from '../../../Components/Layouts/RightSideBar';
import EventDetails from './EventDetails';
import '../../../Styles/Reels/ReelsIndex.css';

function EventDetailsInApp() {
    return (
        <div className="reels-dashboard">
            <div className="topmenubar">
                <SideMenuBar />
                <div className="top-bar-mobile">
                    <TopMenuBar backIconVisible={false} tabName="Events" />
                </div>
            </div>

            <div className="main-container">
                <div className="video-container main-container-reels">
                    <EventDetails embed />
                </div>
                <RightSideBar />
            </div>
        </div>
    );
}

export default EventDetailsInApp;

